import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiClientInterface } from '../../client/api/api-client.interface';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';

@Injectable()
export class TaxClassificationsApiRepository {
    constructor(private apiClient: ApiClientInterface, private transactionRequest: TransactionRequestInterface) {}

    load(classification: string, isLegalPerson: boolean): Observable<Transaction<string[]>> {
        return this.transactionRequest.wrap(this.apiClient.getTaxClassifications(classification, isLegalPerson));
    }
}
